import type { DomainManifest } from 'modules/core/lib/manifests/types'
import { CreateTicketActivity } from 'modules/ticketing/activities/CreateTicket'
import { TicketDetailActivity } from 'modules/ticketing/activities/TicketDetail'
import i18n from 'modules/core/lib/i18n'
import { Inbox } from '@factorialco/f0-react/icons/app'
import { CreateTicketAction } from 'modules/ticketing/lib/oneHandlers/create-ticket'
import { CreateTicketCommentAction } from 'modules/ticketing/lib/oneHandlers/create-ticket-comment'

export const manifest = {
  sidebar: (navigation) => ({
    items: [
      {
        identifier: 'ai_ticketing',
        name: i18n.t('ticketing.sidebar.inbox'),
        factorialOneIcon: Inbox,
        path: navigation.ticketing.fullPath(),
        group: 'it_management',
        module: 'ai_ticketing',
        priority: 'low',
      },
    ],
  }),
  one: {
    createActions: {
      ticket: CreateTicketAction,
      ticketComment: CreateTicketCommentAction,
    },
  },
  activities: {
    createTicket: {
      component: CreateTicketActivity,
      availableForOne: true,
      guidelines:
        'Opens the create ticket dialog to submit a new support ticket. Use when the user wants to create, submit, or file a new ticket.',
      params: {
        title: {
          guidelines: 'The title or subject of the ticket. Extract from the user message.',
        },
        description: {
          guidelines:
            'Detailed description of the issue or request. Extract from the user message.',
        },
        priority: {
          guidelines:
            'Priority level: "low", "medium", "high", or "critical". Infer from context (treat "urgent" as "critical") or default to "medium".',
        },
        assigneeTeamId: {
          guidelines:
            'The ID of the team to assign the ticket to. Use available tools to resolve team names to IDs. Never ask the user for the ID directly.',
        },
      },
    },
    viewTicket: {
      component: TicketDetailActivity,
      availableForOne: true,
      guidelines:
        'Opens the ticket detail panel to view and manage an existing support ticket. Use when the user wants to view, check, inspect, or manage a specific ticket.',
      params: {
        ticketId: {
          guidelines:
            'The ID of the ticket to view. Use available tools to resolve ticket references to IDs. Never ask the user for the ID directly.',
        },
      },
    },
  },
} as const satisfies DomainManifest
